import { api } from '../api'
import { useCachedFetch } from './swr'

// Nom et emoji d'un lieu du portail (ADR-062).
//
// Le module porte son nom depuis `Module.portalNom` (GET /public/modules) — plus
// de « Marche » code en dur : le meme lieu heberge marches, festivals, villages,
// spectacles... Chaque evenement porte son propre type via `EventTypeConfig`.
//
// La lecture passe par le cache SWR persistant deja utilise par l'Explorer :
// aucun appel reseau supplementaire, et le libelle est present des le premier
// rendu au demarrage a froid (pas de flicker « 📦 » puis « Evenements »).

// Replis : servent uniquement au tout premier lancement, hors ligne, avant que
// /public/modules n'ait jamais repondu. Ils doivent rester alignes sur
// PORTAL_LIEUX (apps/backend/src/modules/public/public.service.ts).
const REPLIS = {
  MARCHE: { nom: 'Évènements', emoji: '🎪' },
  TOURNEE: { nom: 'Paniers', emoji: '🧺' },
}

/**
 * @param {string} code code du module ('MARCHE', 'TOURNEE'...)
 * @returns {{ nom: string, emoji: string }}
 */
export function useModuleLabel(code) {
  const { data } = useCachedFetch('/public/modules', () => api.getModules(), { persist: true })
  const lieu = Array.isArray(data) ? data.find((m) => m.code === code) : null
  const repli = REPLIS[code] || { nom: '', emoji: '📦' }
  return {
    nom: lieu?.nom || repli.nom,
    emoji: lieu?.emoji || repli.emoji,
  }
}
